import { RequestMainService } from "../request";

export class AppService {
  static async getList(params: any = {}) {
    return RequestMainService.get(`/admin/apps`, params).then(
      ({ result }) => ({
        count: result?.total,
        data: result.apps,
      })
    );
  }

  static getAppStatus() {
    return [
      { label: "Kích hoạt", value: true },
      { label: "Khóa", value: false },
    ]
  }

  static async delete(id: string | number) {
    return RequestMainService.delete(`/admin/apps/${id}`);
  }

  static async create(payload: any = {}) {
    return RequestMainService.post('/admin/apps', payload).then(
      ({ result }) => result
    );
  }

  static async getDetail(id: string | number) {
    return RequestMainService.get(`/admin/apps/${id}`).then(
      ({ result }) => result
    );
  }

  static async edit(id: string | number, payload: any = {}) {
    return RequestMainService.put(`/admin/apps/${id}`, payload).then(
      ({ result }) => result
    );
  }
}
